/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["hnj",[["AM","PM"]],u,[["S","M","T","W","T","F","S"],["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]],[["S","M","T","W","T","F","S"],["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],["𞄎𞄤𞄲","𞄈𞄦","𞄆𞄨𞄰","𞄗𞄄𞄤𞄰𞄦","𞄙𞄤𞄱𞄨","𞄑𞄤𞄱𞄨","𞄊𞄧𞄳"],["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]],[["1","2","3","4","5","6","7","8","9","10","11","12"],["𞄆𞄬","𞄛𞄨𞄱𞄄𞄤𞄲𞄨","𞄒𞄫𞄰𞄒𞄪𞄱","𞄤𞄨𞄱","𞄀𞄪𞄴","𞄛𞄤𞄱𞄞𞄤𞄦","𞄔𞄩𞄴𞄆𞄨𞄰","𞄕𞄩𞄲𞄔𞄄𞄰𞄤","𞄛𞄤𞄱𞄒𞄤𞄰","𞄪𞄱𞄀𞄤𞄴","𞄚𞄦𞄲𞄤𞄚𞄄𞄰𞄫","𞄒𞄩𞄱𞄔𞄬𞄴"]],u,[["𞄜𞄆𞄪","CE"]],0,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"USD","𞅎",u,{"JPY":["JP¥","¥"],"USD":["𞅎","$"]},"ltr", plural];
